<mat-card>
  <app-card-header
    [title]="'Filtro del agrupamiento'"
    icono="filter_alt"
    [botonCerrar]="true"
    (cerrar)="cancelar()"
  ></app-card-header>

  <mat-card-content class="card-content-crear">
    <!-- Qué eventos -->
    <app-content-card title="Qué eventos" icon="report">
      <section class="inputs-group">
        <ng-select
          class="fp-campo"
          [items]="categorias"
          bindLabel="nombre"
          bindValue="nombre"
          placeholder="Categorías"
          notFoundText="Sin resultados"
          [loading]="cargandoCategorias"
          [multiple]="true"
          [closeOnSelect]="false"
          appendTo="body"
          [(ngModel)]="filtro.categorias"
        >
          <!-- Globo de "global", igual que en listado-categoria-selector y
               modelo-dispositivo-selector -->
          <ng-template ng-option-tmp let-item="item">
            @if (item.global) {
              <span class="material-icons fp-icono-global">public</span>
            }
            {{ item.nombre }}
          </ng-template>
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span
              class="ng-value-icon right irx-clickeable"
              role="button"
              tabindex="0"
              aria-label="Quitar"
              (click)="clear(item)"
              (keydown.enter)="clear(item)"
              >×</span
            >
            @if (item.global) {
              <span class="material-icons fp-icono-global">public</span>
            }
            {{ item.nombre }}
          </ng-template>
        </ng-select>

        <ng-select
          class="fp-campo"
          [items]="tiposEvento"
          bindLabel="label"
          bindValue="valor"
          placeholder="Tipos de evento"
          notFoundText="Sin resultados"
          [multiple]="true"
          [closeOnSelect]="false"
          appendTo="body"
          [(ngModel)]="filtro.tiposEvento"
        ></ng-select>

        <ng-select
          class="fp-campo"
          [items]="estados"
          placeholder="Estados"
          notFoundText="Sin resultados"
          [multiple]="true"
          [closeOnSelect]="false"
          appendTo="body"
          [(ngModel)]="filtro.estados"
        ></ng-select>
      </section>
    </app-content-card>

    <!-- Dónde y de quién -->
    <app-content-card title="Dónde y de quién" icon="crop_free">
      <section class="inputs-group">
        <ng-select
          class="fp-campo"
          [items]="zonas"
          bindLabel="identificacion"
          bindValue="_id"
          groupBy="categoria"
          placeholder="Zonas geográficas"
          notFoundText="Sin resultados"
          [multiple]="true"
          [closeOnSelect]="false"
          appendTo="body"
          [(ngModel)]="filtro.idsZonas"
        >
          <ng-template ng-option-tmp let-item="item">
            <span
              class="fp-color"
              [ngStyle]="{ 'background-color': item?.color || '#ffcc33' }"
            ></span>
            {{ item?.identificacion }}
          </ng-template>
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span
              class="ng-value-icon right irx-clickeable"
              role="button"
              tabindex="0"
              aria-label="Quitar"
              (click)="clear(item)"
              (keydown.enter)="clear(item)"
              >×</span
            >
            <span
              class="fp-color"
              [ngStyle]="{ 'background-color': item?.color || '#ffcc33' }"
            ></span>
            {{ item?.identificacion }}
          </ng-template>
        </ng-select>

        <app-cliente-selector
          class="fp-campo"
          [multiple]="true"
          placeholder="Clientes"
          [(ngModel)]="filtro.idsClientes"
          margin="0"
        ></app-cliente-selector>

        <app-cliente-selector
          class="fp-campo"
          [multiple]="true"
          placeholder="En la jerarquía de"
          [(ngModel)]="filtro.idsAncestros"
          margin="0"
        ></app-cliente-selector>
      </section>
      <section class="inputs-group">
        <small class="ayuda">
          Cada zona alcanza sólo a los eventos de su módulo: una zona de alarmas
          no incluye un gateway que caiga dentro del polígono.
        </small>
      </section>
    </app-content-card>

    <!-- Período, prioridad y repetición -->
    <app-content-card title="Período, prioridad y repetición" icon="tune">
      <section class="inputs-group">
        <app-date-picker
          class="fp-campo"
          mode="daterange"
          label="Período (fecha del evento)"
          [clearable]="true"
          [(ngModel)]="rangoFechas"
          [ngModelOptions]="{ standalone: true }"
          (ngModelChange)="onRangoFechasChange($event)"
        ></app-date-picker>
      </section>

      <section class="inputs-group">
        <mat-form-field class="fp-campo">
          <mat-label>Prioridad desde</mat-label>
          <input
            matInput
            type="number"
            placeholder="Sin mínimo"
            [(ngModel)]="filtro.prioridadDesde"
          />
        </mat-form-field>

        <mat-form-field class="fp-campo">
          <mat-label>Prioridad hasta</mat-label>
          <input
            matInput
            type="number"
            placeholder="Sin máximo"
            [(ngModel)]="filtro.prioridadHasta"
          />
        </mat-form-field>

        <mat-form-field class="fp-campo">
          <mat-label>Repetido al menos</mat-label>
          <input
            matInput
            type="number"
            placeholder="Cualquiera"
            [(ngModel)]="filtro.repetidoDesde"
          />
        </mat-form-field>
      </section>
    </app-content-card>

    <!-- Atención -->
    <app-content-card title="Atención" icon="support_agent">
      <section class="inputs-group">
        <mat-slide-toggle [(ngModel)]="filtro.soloSinAtender">
          Sólo los que nadie está atendiendo
        </mat-slide-toggle>
      </section>
    </app-content-card>
  </mat-card-content>

  <mat-card-actions class="actions-create">
    <button irxBoton="secundario" type="button" (click)="limpiar()">
      <mat-icon>filter_alt_off</mat-icon>
      Limpiar
    </button>
    <span class="pie-espacio"></span>
    <button irxBoton="secundario" type="button" (click)="cancelar()">
      Cancelar
    </button>
    <button irxBoton="principal" type="button" (click)="aplicar()">
      <mat-icon>check</mat-icon>
      Aplicar
    </button>
  </mat-card-actions>
</mat-card>
